export function setHEAS(state, heas) {
    state.heas = heas;
}

export function setHEA(state, hea) {
    state.hea = hea;
}

